import { Field, FormikValues } from "formik";
import React from "react";
import { DateSelector, DropDown } from "@milestone/component-library";
import {
  DateWrapper,
  ErrorWrapper,
  InputContainer,
  Label,
} from "./formComponents.styles";

export const DateSelectWrapper: React.FC<{
  name: string;
  label?: string;
  yearDropdown?: boolean;
  monthDropdown?: boolean;
}> = ({ name, label, yearDropdown = false, monthDropdown = false }) => {
  return (
    <InputContainer>
      <Field name={name}>
        {({ field, meta }: FormikValues) => (
          <>
            <Label htmlFor={name}>
              {label}
              {meta.error && meta.touched ? (
                <ErrorWrapper>{meta.error}</ErrorWrapper>
              ) : null}
            </Label>
            <DateWrapper>
              <DateSelector
                {...field}
                datePickerProps={{
                  showMonthDropdown: monthDropdown,
                  showYearDropdown: yearDropdown,
                  dropdownMode: "select",
                  dateFormat: yearDropdown ? "MMM d y" : undefined,
                }}
              />
            </DateWrapper>
          </>
        )}
      </Field>
    </InputContainer>
  );
};

interface DropDownWrapperProps {
  name: string;
  label: string;
  data: readonly string[];
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
}
export const DropDownWrapper: React.FC<DropDownWrapperProps> = ({
  name,
  label,
  data,
  setFieldValue,
}) => {
  return (
    <InputContainer>
      <Field name={name}>
        {({ field, meta }: FormikValues) => (
          <>
            <Label htmlFor={name}>
              {label}
              {meta.error && meta.touched ? (
                <ErrorWrapper>{meta.error}</ErrorWrapper>
              ) : null}
            </Label>
            <DateWrapper>
              <DropDown {...field} data={data} setFieldValue={setFieldValue} />
            </DateWrapper>
          </>
        )}
      </Field>
    </InputContainer>
  );
};
